if (!customElements.get('product-form')) {
  class ProductForm extends HTMLElement {
    constructor() {
      super();

      // Selectors
      this.form = this.querySelector('form');
      this.submitButton = this.querySelector('[type="submit"]');
      this.cartNotification = document.querySelector('cart-notification');
      this.cartDrawer = document.querySelector('cart-drawer');

      // Event listeners
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    }

    async onSubmitHandler(evt) {
      evt.preventDefault();

      // End Processing state
      this.toggleLoading(true);

      try {
        const formData = new FormData(this.form);
        let fromEntries = Object.fromEntries(formData);
        fromEntries['properties'] = {
          _ref: new Date().getTime(),
        };

        for (const [key, value] of formData.entries()) {
          if (key.startsWith('properties[')) {
            const propertyName = key.split('properties[')[1].split(']')[0];
            fromEntries['properties'][propertyName] = value;
          }
        }

        const body = JSON.stringify({
          ...fromEntries,
          sections: this.getSectionsToRender(),
          sections_url: window.location.pathname,
        });

        // Add to cart request
        const addToCartResponse = await fetch(`${routes.cart_add_url}`, {
          ...fetchConfig(),
          ...{ body },
        });
        const addToCartData = await addToCartResponse.json();

        // Show notification
        this.showNotification(addToCartData);

        // End Processing state
        this.toggleLoading(false);
      } catch (error) {
        console.error(error);
      }
    }

    /**
     * Toggle loading state of submit button
     * @param {*} active: boolean
     */
    toggleLoading(active = true) {
      if (!this.submitButton) return;
      this.submitButton.toggleAttribute('disabled', active);
      this.submitButton.classList.toggle('button--loading', active);
    }

    /**
     * Show add to cart notification to user
     * @param {object} state : add to cart response
     * @returns
     */
    showNotification(state) {
      if (!state) return;

      // Show error message if something went wrong
      if (state.errors) {
        this.cartNotification.setActiveElement(document.activeElement);
        this.cartNotification.renderError(state.errors);
        return;
      }

      // Update cart drawer data
      this.cartDrawer && this.cartDrawer.renderContents(state);

      // Show notification as drawer or notification
      switch (this.submitButton.dataset.addToCartBehavior) {
        case 'open_cart_drawer':
          // Set timeout to force animation. Because content is just updated with renderContents
          setTimeout(() => {
            this.cartDrawer && this.cartDrawer.open();
          });
          break;
        case 'show_cart_notification':
          this.cartNotification.setActiveElement(document.activeElement);
          this.cartNotification.renderContents(state);
      }
    }

    /**
     * @returns Sections to render after add to catt action
     */
    getSectionsToRender() {
      let sections = [...this.cartNotification.getSectionsToRender().map((section) => section.id)];
      if (this.cartDrawer) {
        sections = [
          ...sections,
          ...this.cartDrawer.getSectionsToRender().map((section) => section.id),
        ];
      }
      return sections;
    }
  }

  window.ProductForm = ProductForm;
  customElements.define('product-form', ProductForm);
}
